import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IDeviceOverview } from '@/api/routes/devices/types';
import type { ResponseWithPagination } from '@/utils/types';

import { fetchDevicesOverview } from './actionCreators';

interface InitialState {
  devicesOverview: IDeviceOverview [],
  isLoading: boolean,
  offset: number,
  totalCount: number,
  error: string,
}

const initialState: InitialState = {
  devicesOverview: [],
  offset: 0,
  totalCount: 0,
  isLoading: false,
  error: '',
};

export const devicesOverviewSlice = createSlice({
  name: 'devicesOverview',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchDevicesOverview.fulfilled.type]: (state, action: PayloadAction<ResponseWithPagination<IDeviceOverview>>) => {
      state.isLoading = false;
      state.error = '';
      state.devicesOverview = action.payload.rows;
      state.offset = action.payload.offset;
      state.totalCount = action.payload.total_count;
    },
    [fetchDevicesOverview.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchDevicesOverview.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default devicesOverviewSlice.reducer;
